<template>
    <div>
        <div class="container">
            <container :active_path="path" :plate="plate">
                <div class="base-warp">
                    <div class="head">
                        <div class="title">成员属性列表</div>
                        <div class="btn-box">
                            <el-button type="primary" size="mini" @click="add">添加管理员类型</el-button>
                        </div>
                    </div>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tableData" 
                    border 
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60"></el-table-column>
                        <el-table-column prop="name" label="名称" ></el-table-column>
                        <el-table-column prop="members" label="成员" ></el-table-column>
                        <el-table-column prop="forbidden" label="禁用" align="center">
                            <template slot-scope="s">
                                <span v-if="!s.row.forbidden" class="text-success">正常</span>
                                <span v-else class="text-danger">禁用</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="360">
                            <template slot-scope="s">
                                <el-button type="warning" size="mini" v-if="!s.row.forbidden" @click="forbidden(s.row)">禁用</el-button>
                                <el-button type="success" size="mini" v-if="s.row.forbidden" @click="forbidden(s.row)">恢复</el-button>
                                <el-button type="danger" size="mini" @click="del(s.row)">删除</el-button>
                                <el-button type="primary" size="mini" @click="edit(s.row)" plain>修改权限</el-button>
                                <el-button type="success" size="mini" @click="member(s.row)" plain>管理成员</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    
                </div>
            </container>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import Container from '../../../components/container';
export default {
    components: {
        Container
    },
    data() {
        return {
            plate: '真会投资',
            path: '/applet/member',
            tableData: [],
        }
    },
    mounted () {
        this.getTableData();
    },
    methods: {
        getTableData() {
            this.$api.getAdminTypesList('').then(
                data=>{
                    this.tableData = data;
                }
            )
        },
        add() {
            this.$router.push({path: '/applet/member/add-type'})
        },
        del(row) {
            this.$confirm("是否确定当前管理员类型，删除后管理员账号将不可用").then(
                confirm=>{
                    var params = {
                        id: row._id['$oid'],
                    }
                    this.$api.delAdminTypes(params).then(
                        data=>{
                            this.$message.success(data);
                            this.getTableData();
                        }
                    )
                },
                cancel=>{}
            )
            
        },
        edit(row) {
            var id = row._id['$oid'];
            this.$router.push({path: '/applet/member/edit-type', query:{id}})
        },
        member(row) {
            var id = row._id['$oid'];
            this.$router.push({path: '/applet/member/user', query:{id}})
        },
        forbidden(row) {
            var params = {
                id: row._id['$oid'],
                forbidden: !row.forbidden,
            }
            this.$api.forbiddenAdminTypes(params).then(
                data=>{
                    this.$message.success(data);
                    this.getTableData();
                }
            )
        },
    },
}
</script>

<style lang="scss" scoped>
.base-warp{
    .head{
        .title{
            line-height: 40px;
            float: left;
        }
        .btn-box{
            float: right;
        }
    }
}

</style>